/**
 * @generated SignedSource<<39804f8e69e0f5098b5b687995c56f2d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedCreatorTopContent_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbRespContentModuleSelector_viewer">;
  readonly " $fragmentType": "SbSharedCreatorTopContent_viewer";
};
export type SbSharedCreatorTopContent_viewer$key = {
  readonly " $data"?: SbSharedCreatorTopContent_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedCreatorTopContent_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedCreatorTopContent_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespContentModuleSelector_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "9b46e6f38eacf518df681d833ce4d6e9";

export default node;
